var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaLinkEsterno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icona_link_esterno",
    "data-name": "icona link esterno",
    d: "M8.7,21.394,19.76,10.336v4.781a1.333,1.333,0,1,0,2.667,0v-8a1.331,1.331,0,0,0-1.333-1.333h-8a1.333,1.333,0,1,0,0,2.667h4.781L6.817,19.508A1.333,1.333,0,0,0,8.7,21.394Z",
    transform: "translate(-6.427 -5.784)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaLinkEsterno);
export default __webpack_public_path__ + "static/media/icona_link_esterno.a6d1dd7c112d77ffcee481d8695bd143.svg";
export { ForwardRef as ReactComponent };